<template>
  <div class="index">
    <div class="banner">
      <el-carousel trigger="click" height="33.85vw" arrow="always">
        <el-carousel-item v-for="(item, j) in imglist" :key="j">
          <img :src="item" alt="" class="bannerimg" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="news">
      <div class="newstitle">
        <img src="../assets/image/newstitle.png" alt="" class="newsimg" />
      </div>
      <div class="newstitleimg" style="position: relative">
        <img
          style="
            width: 0.73vw;
            height: 0.99vw;
            position: absolute;
            top: -0.78vw;
          "
          src="../assets/image/news_jt.gif"
          alt=""
        />
      </div>
      <el-carousel
        indicator-position="outside"
        height="20.83vw"
        arrow="never"
        @change="onChange"
      >
        <el-carousel-item v-for="item in newspage" :key="item">
          <div class="newscontent">
            <div
              class="newslist"
              v-for="(i, j) in newslist"
              :key="j"
              @mouseenter="newsclick(j)"
              @mouseleave="newsclick(-1)"
              :style="{ marginTop: newsclicks == j ? '-0.52vw' : '0' }"
              style="display: flex"
              @click="checkinfo(i)"
            >
              <div class="listicon">
                <img :src="i.firstUrl" alt="" class="listimg" />
                <div class="listtime" style="display: flex">
                  {{ i.publishTime }}
                </div>
              </div>
              <div class="listcontent">
                <h1 class="listtitle">
                  {{ i.title }}
                </h1>
                <p class="listcon">{{ i.summary }}</p>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="product">
      <div class="protitle">
        <img src="../assets/image/producttitle.png" alt="" class="proimg" />
      </div>
      <div class="protitleimg" style="position: relative">
        <img
          src="../assets/image/news_jt.gif"
          alt=""
          style="width: 0.73vw; height: 0.99vw; position: absolute; top: 0"
        />
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="i.name"
          :name="i.name"
          v-for="(i, j) in tabslist"
          :key="i.name"
        >
          <div class="prochildren">
            <div class="listbox" v-if="i.children.length > 0">
              <div
                class="childrenlist"
                v-for="(k, l) in i.children"
                :key="k.name"
                :class="activechild == l ? 'childactive' : ''"
                @click="childclick(j, l)"
              >
                {{ k.name }}
              </div>
            </div>
            <div class="childcontent">
              <Tlzf v-if="senddata" :senddata="senddata" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="development">
      <div class="devtitle">
        <img src="../assets/image/devtitle.png" alt="" class="devimg" />
      </div>
      <div class="devtitleimg" style="position: relative">
        <img
          src="../assets/image/news_jt.gif"
          alt=""
          style="
            width: 0.73vw;
            height: 0.99vw;
            position: absolute;
            top: -0.78vw;
          "
        />
      </div>
      <div class="devcontent">
        <div class="devroll"></div>
        <div class="arrow arrowleft" @click="toleft"></div>
        <div class="arrow arrowright" @click="toright"></div>
        <div
          class="timeline"
          ref="timeline"
          @scroll="scrolls"
          @mouseenter="stopmove"
          @mouseleave="startmove"
        >
          <div class="timecontent" ref="timecontent">
            <div class="line"></div>
            <div
              class="timetop timesingle"
              v-for="(i, j) in timeline"
              :key="j"
              :style="{
                'margin-left': `${22.4 * j}vw`,
              }"
            >
              <div style="display: flex" v-if="i.xy == 'top'" class="showtop">
                <div class="singleleft">
                  <div class="lefttitle">{{ i.showtitle }}</div>
                </div>
                <div class="singleright">
                  <h1 class="singlerighttitle">{{ i.title }}</h1>
                  <p class="singlerightcon">{{ i.content }}</p>
                </div>
              </div>
            </div>
            <div
              class="timebot timesingle"
              v-for="(i, j) in timeline"
              :style="{
                'margin-left': `${22.4 * j}vw`,
              }"
            >
              <div style="display: flex" v-if="i.xy == 'bot'" class="showbot">
                <div class="singleleft">
                  <div class="lefttitle">{{ i.showtitle }}</div>
                </div>
                <div class="singleright">
                  <h1 class="singlerighttitle">{{ i.title }}</h1>
                  <p class="singlerightcon">{{ i.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="linkto">
      <div class="linktotitle">
        <img src="../assets/image/linkto.png" alt="" class="linkimg" />
      </div>
      <div class="linktotitleimg" style="position: relative; height: 1.46vw">
        <img
          src="../assets/image/news_jt.gif"
          alt=""
          style="
            width: 0.73vw;
            height: 0.99vw;
            position: absolute;
            top: -0.78vw;
          "
        />
      </div>
      <div class="linkcontent">
        <div class="links" @click="turnto('https://www.mohurd.gov.cn/')">
          <img src="../assets/image/link1.png" alt="" class="linksingle" />
        </div>
        <div class="links" @click="turnto('http://www.crecg.com/')">
          <img
            src="../assets/image/link2.png"
            alt=""
            class="linksingle"
            style="width: 4.53vw; height: 3.33vw"
          />
        </div>
        <div class="links" @click="turnto('http://www.crceg.com/')">
          <img
            src="../assets/image/link3.png"
            alt=""
            class="linksingle"
            style="width: 13.96vw; height: 3.75vw"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tlzf from "./tlzf.vue";
export default {
  components: { Tlzf },
  data() {
    return {
      newsclicks: "",
      imglist: [
        // "https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/2024-01-24/%E9%A6%96%E9%A1%B5banner1-1706089129451.png?q-sign-algorithm=sha1&q-ak=AKIDvvoX3LQjx6GSWO2jFZlmaCdqqeM0Tjmm&q-sign-time=1706089131%3B3282889131&q-key-time=1706089131%3B3282889131&q-header-list=host&q-url-param-list=&q-signature=4d375d94290875b9155f6cb6454d866f413b7df5",
        // "https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/2024-01-24/%E9%A6%96%E9%A1%B5banner2-1706089299564.png?q-sign-algorithm=sha1&q-ak=AKIDvvoX3LQjx6GSWO2jFZlmaCdqqeM0Tjmm&q-sign-time=1706089301%3B3282889301&q-key-time=1706089301%3B3282889301&q-header-list=host&q-url-param-list=&q-signature=4e2afcc9d136a3a1f67900afd94b0949c542f952",
        // "https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/2024-01-24/%E9%A6%96%E9%A1%B5banner3-1706089320141.png?q-sign-algorithm=sha1&q-ak=AKIDvvoX3LQjx6GSWO2jFZlmaCdqqeM0Tjmm&q-sign-time=1706089322%3B3282889322&q-key-time=1706089322%3B3282889322&q-header-list=host&q-url-param-list=&q-signature=d61bf6cb0e3682da526335bb397ae7a84afa4ed6",
        // "https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/2024-01-24/%E9%A6%96%E9%A1%B5banner4-1706089334725.png?q-sign-algorithm=sha1&q-ak=AKIDvvoX3LQjx6GSWO2jFZlmaCdqqeM0Tjmm&q-sign-time=1706089338%3B3282889338&q-key-time=1706089338%3B3282889338&q-header-list=host&q-url-param-list=&q-signature=cfa9761553c22f84d028cfcd14ce05101921b6b8",
        // "https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/2024-01-24/%E9%A6%96%E9%A1%B5banner5-1706089351118.png?q-sign-algorithm=sha1&q-ak=AKIDvvoX3LQjx6GSWO2jFZlmaCdqqeM0Tjmm&q-sign-time=1706089354%3B3282889354&q-key-time=1706089354%3B3282889354&q-header-list=host&q-url-param-list=&q-signature=befa9bdf66444e8b0ed15884ad0dff5035a5cc40",
          "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/%E9%A6%96%E9%A1%B5banner5-1706089351118.png",
          "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/%E9%A6%96%E9%A1%B5banner4-1706089334725.png",
          "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/%E9%A6%96%E9%A1%B5banner3-1706089320141.png",
          "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/%E9%A6%96%E9%A1%B5banner2-1706089299564.png",
          "https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/%E9%A6%96%E9%A1%B5banner1-1706089129451.png"

      ],
      newspage: 0,
      newslist: [],
      tabslist: [
        {
          name: "施工总承包",
          children: [
            {
              name: "铁路站房",
              content: [
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "调度所及铁路配套工程",
              content: [
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "机场",
              content: [
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "文化场馆",
              content: [
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "体育场馆",
              content: [
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "学校",
              content: [
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "地产住宅",
              content: [
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "医疗养老",
              content: [
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },

            {
              name: "城市综合体",
              content: [
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "科研基地和研发中心",
              content: [
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
          ],
        },
        {
          name: "工程总承包",
          children: [],
          content: [
            { name: "雄安站", icon: require("../assets/image/case8.png") },
            { name: "雄安站", icon: require("../assets/image/case2.png") },
            { name: "雄安站", icon: require("../assets/image/case3.png") },
            { name: "雄安站", icon: require("../assets/image/case4.png") },
            { name: "雄安站", icon: require("../assets/image/case5.png") },
            { name: "雄安站", icon: require("../assets/image/case6.png") },
          ],
        },
        {
          name: "基础设施",
          children: [
            {
              name: "铁路交通",
              content: [
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
              ],
            },
            {
              name: "轨道交通",
              content: [
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
          ],
        },
        {
          name: "建筑工业化",
          children: [],
          content: [
            { name: "雄安站", icon: require("../assets/image/case8.png") },
            { name: "雄安站", icon: require("../assets/image/case2.png") },
            { name: "雄安站", icon: require("../assets/image/case3.png") },
            { name: "雄安站", icon: require("../assets/image/case4.png") },
          ],
        },
        {
          name: "专业领域",
          children: [
            {
              name: "装饰",
              content: [
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
              ],
            },
            {
              name: "安装",
              content: [
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
              ],
            },
            {
              name: "绿色产业",
              content: [
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "科技创新",
              content: [
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case3.png") },
                { name: "雄安站", icon: require("../assets/image/case4.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
            {
              name: "机械",
              content: [
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case1.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case2.png") },
                { name: "雄安站", icon: require("../assets/image/case5.png") },
                { name: "雄安站", icon: require("../assets/image/case6.png") },
              ],
            },
          ],
        },
      ],
      activeName: "施工总承包",
      fathernum: "",
      activechild: "0",
      senddata: null,
      timeline: [
        {
          xy: "top",
          title: "【新中国成立初期】",
          showtitle: "成立初期",
          content:
            "中铁建工集团一公司成立于国家'一五计划'开局之年，前身为铁道部建厂工程公司第一建筑工程处。1959年，仅用7个月零20天，建成中国第一座大型火车站————北京站，创造了中国建筑史上的奇迹。",
        },
        {
          xy: "bot",
          title: "【60年代】",
          showtitle: "60年代",
          content:
            "公司响应党中央'三线建设'重大战略决策，千里奔赴四川资阳，建成资阳内燃机车厂、永济电机厂、偃师摩托车厂等重点工程，为我国国民经济发展和国防现代化建设作出重要贡献",
        },
        {
          xy: "top",
          title: "【70年代】",
          showtitle: "70年代",
          content:
            "公司听从国家召唤，奉命组建援建坦桑铁路的施工队伍。1976年，全长1860公里的坦赞铁路正式交付，见证了中非患难与共的珍贵情谊。1978年，总部迁回北京，建设了北方交通大学扩建工程、铁道部大红门材料厂等工程。",
        },
        {
          xy: "bot",
          title: "【90年代】",
          showtitle: "90年代",
          content:
            "公司在行业内率先推行全面质量管理，推出精品工程生产线质量管理体系和用户服务保障体系，全面提升管理品质，履约能力和品牌美誉度，亮马河大厦、幸福大厦获得全国首批鲁班奖，公司获评国家建筑施工一级企业。",
        },
        {
          xy: "top",
          title: "【21世纪初】",
          showtitle: "21世纪初",
          content:
            "公司不断精进专业实力，国家图书馆万吨钢结构整体提升创造世界纪录，同时摘得鲁班奖、詹天佑奖；承建中国高铁第一站——北京南站，始终保持铁路站房、公众建筑建设领域的行业领先地位。",
        },
        {
          xy: "bot",
          showtitle: "十三五时期",
          title: "【十三五时期】",
          content:
            "公司抢抓市场机遇，承建雄安站、清河站、北京丰台站、北京城市副中心站等重大铁路站房，叫响“铁路站房建设王牌军”金字招牌。提质量增效益，经济指标屡创新高，稳居中国中铁20强前三。",
        },
        {
          xy: "top",
          showtitle: "十四五时期",
          title: "【十四五时期】",
          content:
            "公司持续推进转型升级，构建“1+6”市场布局，建立“总部一分公司一项目部”三级管理模式，明确“十四五”期间的奋斗目标：“工程总承包第一品牌，高质量发展行业典范”,绘制公司未来发展的壮阔蓝图。",
        },
      ],
      timedata: [
        {
          xy: "top",
          title: "【新中国成立初期】",
          showtitle: "成立初期",
          content:
            "中铁建工集团一公司成立于国家'一五计划'开局之年，前身为铁道部建厂工程公司第一建筑工程处。1959年，仅用7个月零20天，建成中国第一座大型火车站————北京站，创造了中国建筑史上的奇迹。",
        },
        {
          xy: "bot",
          title: "【60年代】",
          showtitle: "60年代",
          content:
            "公司响应党中央'三线建设'重大战略决策，千里奔赴四川资阳，建成资阳内燃机车厂、永济电机厂、偃师摩托车厂等重点工程，为我国国民经济发展和国防现代化建设作出重要贡献",
        },
        {
          xy: "top",
          title: "【70年代】",
          showtitle: "70年代",
          content:
            "公司听从国家召唤，奉命组建援建坦桑铁路的施工队伍。1976年，全长1860公里的坦赞铁路正式交付，见证了中非患难与共的珍贵情谊。1978年，总部迁回北京，建设了北方交通大学扩建工程、铁道部大红门材料厂等工程。",
        },
        {
          xy: "bot",
          title: "【90年代】",
          showtitle: "90年代",
          content:
            "公司在行业内率先推行全面质量管理，推出精品工程生产线质量管理体系和用户服务保障体系，全面提升管理品质，履约能力和品牌美誉度，亮马河大厦、幸福大厦获得全国首批鲁班奖，公司获评国家建筑施工一级企业。",
        },
        {
          xy: "top",
          title: "【21世纪初】",
          showtitle: "21世纪初",
          content:
            "公司不断精进专业实力，国家图书馆万吨钢结构整体提升创造世界纪录，同时摘得鲁班奖、詹天佑奖；承建中国高铁第一站——北京南站，始终保持铁路站房、公众建筑建设领域的行业领先地位。",
        },
        {
          xy: "bot",
          showtitle: "十三五时期",
          title: "【十三五时期】",
          content:
            "公司抢抓市场机遇，承建雄安站、清河站、北京丰台站、北京城市副中心站等重大铁路站房，叫响“铁路站房建设王牌军”金字招牌。提质量增效益，经济指标屡创新高，稳居中国中铁20强前三。",
        },
        {
          xy: "top",
          showtitle: "十四五时期",
          title: "【十四五时期】",
          content:
            "公司持续推进转型升级，构建“1+6”市场布局，建立“总部一分公司一项目部”三级管理模式，明确“十四五”期间的奋斗目标：“工程总承包第一品牌，高质量发展行业典范”,绘制公司未来发展的壮阔蓝图。",
        },
      ],
      scroll: {},
      timer: {},
      scrollvalue: 2,
    };
  },
  methods: {
    checkinfo(e) {
      let data = {
        category: "首页/新闻中心",
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/news/info",
        query: data,
      });
    },
    async getplist(e) {
      let data = {
        category: e,
        current: 1,
        size: 8,
      };
      let res = await this.$http.plist(data);
      if (res.code == 200) {
        this.senddata = res.data;
      }
    },
    onChange(e) {
      this.getnewslist(e + 1);
    },
    async getnewslist(e) {
      let data = {
        category: "首页/新闻中心",
        current: e,
        size: 4,
      };
      let res = await this.$http.newslist(data);
      if (res.code == 200) {
        this.newslist = res.data;
        this.newspage = Math.ceil(res.total / 4);
        if (this.newspage > 3) {
          this.newspage = 3;
        }
      }
    },
    scrolls(e) {
      // console.log(e.target.scrollLeft);
    },
    stopmove() {
      clearInterval(this.timer);
    },
    startmove() {
      this.roll();
    },
    toleft() {
      this.scrollvalue = -2;
    },
    toright() {
      this.scrollvalue = 2;
    },
    roll() {
      this.timer = setInterval(() => {
        this.$refs.timeline.scrollLeft += this.scrollvalue;
      }, 20);
    },
    scrollListener() {
      let arr = [];
      arr = [...this.timedata];
      let parentBox = this.$refs.timeline; //获取滚动区域的dom
      let scrollBox = this.$refs.timecontent;
      //监听滚动
      parentBox.addEventListener(
        "scroll",
        () => {
          let myWidth = parentBox.scrollLeft - scrollBox.clientWidth;
          let num = myWidth / 1506;
          if (Number.isInteger(num)) {
            this.timeline.push(...arr);
          }
          if (parentBox.scrollLeft == 0) {
            this.toright();
            return;
          }
        },
        true
      );
    },
    turnto(e) {
      window.open(e);
    },
    childclick(f, l) {
      this.fathernum = f;
      this.activechild = l;
      let str = "产品系列/";
      for (let i in this.tabslist) {
        if (i == f) {
          str += this.tabslist[i].name;
          for (let j in this.tabslist[i].children) {
            if (j == l) {
              // this.senddata = this.tabslist[i].children[l].name;
              str += `/${this.tabslist[i].children[l].name}`;
              this.getplist(str);
            }
          }
        }
      }
    },
    handleClick(f) {
      this.fathernum = f.index;
      this.activechild = 0;
      let str = "产品系列/";
      for (let i in this.tabslist) {
        if (i == f.index) {
          if (this.tabslist[i].children.length > 0) {
            str += this.tabslist[i].name;
            for (let j in this.tabslist[i].children) {
              if (j == 0) {
                str += `/${this.tabslist[i].children[j].name}`;
                this.getplist(str);
              }
            }
          } else {
            str += this.tabslist[i].name;
            this.getplist(str);
          }
        }
      }
    },
    newsclick(e) {
      this.newsclicks = e;
    },
  },
  mounted() {
    this.childclick(0, 0);
    this.roll();
    this.getnewslist(1);
    this.getplist("产品系列/施工总承包/铁路站房");
    this.scrollListener();
  },
  destroyed() {
    this.scroll.destroy();
  },
};
</script>

<style scoped lang="less">
.index {
  width: 100vw;
  .product {
    ::v-deep .el-tabs__nav-wrap::after {
      height: 0 !important;
    }
    ::v-deep .el-tabs__item {
      font-size: 1.04vw !important;
      color: rgba(6, 25, 45, 0.7) !important;
      font-weight: 600 !important;
    }
    ::v-deep .el-tabs__active-bar {
      height: 0.16vw !important;
      color: rgba(25, 97, 172, 1) !important;
      background-color: rgba(25, 97, 172, 1) !important;
    }
    ::v-deep .is-active {
      color: rgba(25, 97, 172, 1) !important;
    }
    .childcontent {
      width: 72.92vw;
      display: flex;
      justify-content: center;
    }
    .prochildren {
      .listbox {
        .childactive {
          color: white !important;
          background: #1961ac !important;
          border: 0.05vw solid #1961ac !important;
        }
        .childrenlist {
          width: auto;
          padding: 0vw 0.73vw;
          height: 1.88vw;
          color: rgba(6, 25, 45, 0.8);
          font-size: 0.83vw;
          border-radius: 0.21vw;
          border: 0.05vw solid rgba(6, 25, 45, 0.5);
          background: #ffffff;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        display: flex;
        gap: 0.83vw;
        height: 1.88vw;
        justify-content: center;
        align-items: center;
        margin-bottom: 2.08vw;
      }

      width: 100%;
      background: rgba(244, 246, 249, 1);
      padding: 1.25vw 13.54vw 4.17vw 13.54vw;
    }
    .protitle {
      .proimg {
        width: 18.5vw;
        height: 5.1vw;
      }
      width: 100%;
      height: 5.1vw;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 1.56vw;
      background: #fff;
    }
    .protitleimg {
      .proimg {
        width: 18.5vw;
        height: 5.1vw;
      }
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.9896vw;
      padding-top: 1.56vw;
      background: #fff;
    }
    width: 100%;
    background: white;
  }
  .development {
    .devcontent {
      .timeline {
        .timecontent {
          .timebot {
            .singleleft {
              .lefttitle {
                font-size: 1.04vw;
                color: rgba(25, 97, 172, 1);
                height: 2.19vw;
                width: 100%;
                line-height: 2.19vw;
                top: 4.4vw;
                text-align: center;
                position: absolute;
                left: 0;
              }
              padding: 0 0.52vw;
              margin-right: 0.52vw;
              width: 6.51vw;
              height: 6.61vw;
              background: url("../assets/image/timebotus.png") no-repeat;
              background-position: 0 0;
              background-size: 100% 100%;
              position: relative;
            }
            .singlerighttitle {
              margin-top: 4.3vw;
            }
            width: 22.4vw;
            height: 10.26vw;
            bottom: 1.88vw;
            position: relative;
          }
          .timetop {
            width: 22.4vw;
            height: 11.15vw;
            top: 1.2vw;
            .singleleft {
              .lefttitle {
                font-size: 1.04vw;
                color: rgba(25, 97, 172, 1);
                height: 2.19vw;
                line-height: 2.19vw;
                top: 0.31vw;
                left: 0.42vw;
                text-align: center;
              }
              padding: 0 0.52vw;
              margin-right: 0.52vw;
              width: 6.51vw;
              // height: 6.25vw;
              background: url("../assets/image/timetopus.png") no-repeat;
              background-position: 0 0;
              background-size: 100% 100%;
            }
          }
          .timesingle {
            .singleright {
              .singlerightcon {
                font-size: 0.73vw;
                color: rgba(6, 25, 45, 0.6);
              }
              .singlerighttitle {
                font-size: 0.83vw;
                color: #06192d;
                margin-bottom: 0.52vw;
              }
              flex: 1;
              max-width: 15.63vw;
            }

            position: absolute;
            display: flex;
          }
          .line {
            width: 802.4vw !important;
            height: 0.05vw;
            background: url("../assets/image/line.png") no-repeat;
            background-position: 0 0;
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 50%;
          }
          width: 156.77vw;
          height: 100%;
        }
        width: 97%;
        height: 100%;
        padding: 0 2.08vw;
        overflow-x: scroll;
        position: relative;
        scrollbar-width: none !important; /* firefox */
        -ms-overflow-style: none !important; /* IE 10+ */
      }
      .timeline::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .arrowright {
        background: url("../assets/image/jianto2.png") no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        top: calc(11.72vw - 1.04vw);
        right: 0;
      }
      .arrowright:hover {
        background: url("../assets/image/arrowrightblue.png") no-repeat;
      }
      .arrowleft:hover {
        background: url("../assets/image/arrowleftblue.png") no-repeat;
      }
      .arrowleft {
        background: url("../assets/image/jiantou.png") no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        top: calc(11.72vw - 1.04vw);
        left: -2.08vw;
      }
      .arrow {
        width: 2.08vw;
        height: 2.08vw;
        position: absolute;
      }
      .devroll {
        width: 19.27vw;
        height: 19.27vw;
        background: url("../assets/image/roll.png") no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        position: absolute;
        right: 8.63vw;
        animation: rotate 5s linear infinite;
      }
      @keyframes rotate {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
      width: 100%;
      height: 23.44vw;
      position: relative;
    }
    .devtitle {
      .devimg {
        width: 35.89vw;
        height: 5.1vw;
      }
      width: 100%;
      height: 5.1vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .devtitleimg {
      .devimg {
        width: 35.89vw;
        height: 5.1vw;
      }
      width: 100%;
      height: 3.02vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    width: 100%;
    height: 37.5vw;
    background: url("../assets/image/devbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: 0 0;
    padding: 1.56vw 13.54vw 4.06vw 13.54vw;
  }
  .linkto {
    .linkcontent {
      .links:hover {
        margin-top: -0.52vw;
      }
      .links {
        .linksingle {
          width: 19.79vw;
          height: 8.33vw;
        }
        width: 19.79vw;
        height: 8.33vw;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: #fff;
        box-shadow: 0vw 0.16vw 0.78vw 0vw rgba(68, 86, 103, 0.15);
      }
      width: 100%;
      height: 8.33vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .linktotitle {
      .linkimg {
        width: 10.36vw;
        height: 100%;
      }
      width: 100%;
      height: 5.1vw;
      display: flex;
      justify-content: center;
    }
    .linktotitleimg {
      .linkimg {
        width: 10.36vw;
        height: 100%;
      }
      width: 100%;
      height: 5.1vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    width: 100%;
    height: 20.75vw;
    background: rgba(243, 245, 249, 0.8);
    padding: 1.56vw 13.54vw 3.65vw 13.54vw;
  }
  .news {
    .newscontent {
      .newslist {
        .listcontent {
          .listcon {
            width: 22.4vw;
            font-size: 0.73vw;
            pointer-events: none;
            color: rgba(6, 25, 45, 0.68);
            font-weight: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4; /*省略几行写几*/
            -webkit-box-orient: vertical;
            height: 4.17vw;
          }
          .listtitle {
            width: 22.4vw;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1; /*省略几行写几*/
            -webkit-box-orient: vertical;
            height: 1.25vw;
            text-overflow: ellipsis;
            font-size: 1.04vw;
            color: #000;
            margin-bottom: 0.83vw;
            pointer-events: none;
            font-weight: 500;
          }
          flex: 1;
          display: flex;
          flex-direction: column;
          pointer-events: none;
        }
        .listicon {
          .listtime {
            position: absolute;
            bottom: 0;
            left: 0;
            pointer-events: none;
            width: 10.42vw;
            height: 1.56vw;
            background: rgba(3, 109, 220, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-size: 0.94vw;
          }
          .listimg {
            width: 10.42vw;
            height: 6.67vw;
            pointer-events: none;
          }
          width: 10.42vw;
          height: 6.67vw;
          position: relative;
          margin-right: 1.04vw;
          pointer-events: none;
        }
        width: 35.94vw;
        height: 8.75vw;
        background: #fff;
        padding: 1.04vw;
        display: flex;
      }
      width: 72.92vw;
      height: 20.94vw;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      display: flex !important;
    }
    .newstitle {
      .newsimg {
        width: 10.36vw;
        height: 5.1vw;
      }
      width: 100%;
      height: 5.1vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .newstitleimg {
      .newsimg {
        width: 10.36vw;
        height: 5.1vw;
      }
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 2.08vw;
    }
    width: 100%;
    height: 35.42vw;
    background: url("../assets/image/newsbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: 0 0;
    padding: 1.56vw 13.54vw 3.13vw 13.54vw;
  }
  .banner {
    ::v-deep .el-icon-arrow-left:before {
      font-size: 1.25vw;
    }
    ::v-deep .el-icon-arrow-right:before {
      font-size: 1.25vw;
    }
    ::v-deep .el-carousel__arrow:hover {
      background: rgba(255, 255, 255, 0.4);
    }
    ::v-deep .el-carousel__arrow {
      background: rgba(0, 0, 0, 0.4);
      width: 2.5vw;
      height: 2.5vw;
    }
    ::v-deep .el-carousel__arrow--left {
      left: 13.54vw !important;
    }
    ::v-deep .el-carousel__arrow--right {
      right: 13.54vw !important;
    }
    .bannerimg {
      width: 100%;
      height: 33.85vw;
    }
    width: 100%;
    height: 33.85vw;
  }
}
::v-deep .el-tabs__nav-scroll {
  display: flex !important;
  justify-content: center !important;
}
::v-deep.el-tabs__item {
  font-size: 1.04vw !important;
  color: rgba(6, 25, 45, 0.7) !important;
  font-weight: 600 !important;
}
::v-deep.el-tabs__item:hover {
  color: #1968bc !important;
}
::v-deep.el-tabs__nav-wrap::after {
  width: 0 !important;
  height: 0 !important;
}
.showtop:hover .singleleft {
  background: url("../assets/image/timetop.png") no-repeat !important;
}
.showtop:hover .lefttitle {
  color: white !important;
}
.showbot:hover .singleleft {
  background: url("../assets/image/timebot.png") no-repeat !important;
}
.showbot:hover .lefttitle {
  color: white !important;
}
::v-deep.news .el-carousel__indicators .is-active .el-carousel__button {
  height: 0.31vw !important;
  width: 1.56vw !important;
  background: rgba(0, 107, 208, 1) !important;
}
::v-deep.el-carousel .el-carousel__button {
  width: 0.52vw !important;
  height: 0.31vw !important;
  background: rgba(6, 25, 45, 0.3) !important;
  border-radius: 0.21vw;
}
</style>
